// This file is only a template for services.  Copy and paste this to your application's service .ts file and start off from there
// Rename all things with KnowledgeBook.
// Naming convention for services is "[App Name]Services.ts" i.e. UsersServices.ts, EntitlementServices.ts

import * as Inovx from '@shared';
import assign from 'object-assign';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/Schema`;

var SchemaServices: ISchemaService = assign({}, Inovx.Shared.Flux.BaseService, {
    getAll: function () {
        return new Promise<ISchema[]>((resolve, reject) => {
            this.get(url,
                null,
                (retData: ISchema[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssetClassesUpdateData: function (schemaID: string) {
        return new Promise<IAssetClassUpdateDetail[]>((resolve, reject) => {
            this.get(`${url}/AssetClass/GetUpdateData`,
                { schemaID: schemaID },
                (retData: IAssetClassUpdateDetail[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAnnotationClassesUpdateData: function (schemaID: string) {
        return new Promise<IAssetClassUpdateDetail[]>((resolve, reject) => {
            this.get(`${url}/AnnotationClass/GetUpdateData`,
                { schemaID: schemaID },
                (retData: IAssetClassUpdateDetail[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssetSetTaxonomyDetail: function (schemaID: string) {
        return new Promise<ILibraryTaxonomyDetail>((resolve, reject) => {
            this.get(`${url}/${schemaID}/AssetSetTaxonomy`,
                null,
                (retData: ILibraryTaxonomyDetail) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    updateAssetSetTaxonomyDetail: function (schemaID: string, taxonomy: ILibraryTaxonomyDetail) {
        return new Promise<ILibraryTaxonomyDetail>((resolve, reject) => {
            this.post(`${url}/${schemaID}/AssetSetTaxonomy/Update`,
                taxonomy,
                (retData: ILibraryTaxonomyDetail) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    create: function (schema: ISchema) {
        return new Promise<ISchema>((resolve, reject) => {
            this.post(`${url}/Create`,
                schema,
                (retData: ISchema) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    update: function (schema: ISchema) {
        return new Promise<ISchema>((resolve, reject) => {
            this.post(`${url}/Update`,
                schema,
                (retData: ISchema) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    deleteSchema: function (schema: ISchema) {
        return new Promise<void>((resolve, reject) => {
            const payload: any = { ID: schema.ID };
            if (schema.VersionToken) {
                payload.VersionToken = schema.VersionToken;
            }

            this.post(`${url}/Delete`,
                payload,
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    try {
                        const errJson = JSON.parse(error.responseText);
                        if (errJson.Reason === "ObjectCannotBeDeleted") {
                            reject({ handled: false, message: errJson.Message });
                            return;
                        }
                    }
                    catch {}

                    this.handleWebApiError(error);
                    reject({ handled: true });
                }
            );
        });
    },
    createAssetClass: function (cls: IAssetClassUpdateDetail) {
        return new Promise<IAssetClass>((resolve, reject) => {
            this.post(`${url}/AssetClass/Create`,
                cls,
                (retData: IAssetClass) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    updateAssetClass: function (cls: IAssetClassUpdateDetail) {
        return new Promise<IAssetClass>((resolve, reject) => {
            this.post(`${url}/AssetClass/Update`,
                cls,
                (retData: IAssetClass) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    deleteAssetClass: function (cls: IAssetClassUpdateDetail) {
        return new Promise<void>((resolve, reject) => {
            const payload: any = { ID: cls.ID };
            if ((cls as any).VersionToken) {
                payload.VersionToken = (cls as any).VersionToken;
            }

            this.post(`${url}/AssetClass/Delete`,
                payload,
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    try {
                        var errJson = JSON.parse(error.responseText);
                        if (errJson.Reason === "ObjectCannotBeDeleted") {
                            reject({ handled: false, message: errJson.Message });
                            return;
                        }
                    }
                    catch {}

                    this.handleWebApiError(error);
                    reject({handled: true});
                }
            );
        });
    },
    createAnnotationClass: function (cls: IAssetClassUpdateDetail) {
        return new Promise<IAssetClass>((resolve, reject) => {
            this.post(`${url}/AnnotationClass/Create`,
                cls,
                (retData: IAssetClass) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    updateAnnotationClass: function (cls: IAssetClassUpdateDetail) {
        return new Promise<IAssetClass>((resolve, reject) => {
            this.post(`${url}/AnnotationClass/Update`,
                cls,
                (retData: IAssetClass) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    deleteAnnotationClass: function (cls: IAssetClassUpdateDetail) {
        return new Promise<void>((resolve, reject) => {
            const payload: any = { ID: cls.ID };
            if ((cls as any).VersionToken) {
                payload.VersionToken = (cls as any).VersionToken;
            }

            this.post(`${url}/AnnotationClass/Delete`,
                payload,
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    try {
                        var errJson = JSON.parse(error.responseText);
                        if (errJson.Reason === "ObjectCannotBeDeleted") {
                            reject({ handled: false, message: errJson.Message });
                            return;
                        }
                    }
                    catch {}

                    this.handleWebApiError(error);
                    reject({ handled: true });
                }
            );
        });
    }
    
});

export default SchemaServices;
